/**
 * Subscribes to a media query.
 *
 * The layout breakpoint is a real branch, not only a CSS one: a closed drawer
 * has to be `inert` so it is out of the tab order, and "closed" is meaningless
 * once the sidebar is persistent. See `AppLayout`.
 */
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => globalThis.matchMedia?.(query).matches ?? false);

  useEffect(() => {
    const list = globalThis.matchMedia?.(query);
    if (!list) return;
    setMatches(list.matches);
    const onChange = (event: MediaQueryListEvent): void => {
      setMatches(event.matches);
    };
    list.addEventListener('change', onChange);
    return () => {
      list.removeEventListener('change', onChange);
    };
  }, [query]);

  return matches;
}

/** Above this the sidebar is persistent; below it, a drawer. */
export const SIDEBAR_BREAKPOINT = '(min-width: 48rem)';
